import { Component, Input, OnInit } from "@angular/core";
import { ReplaySubject, Subject } from "rxjs";
import * as _ from "lodash";
import { FilterSettings } from "models/reports/filters/FilterSettings";
import { I18NService } from "services/i18n/I18NService";
import {
    FilterSetting,
    FilterType,
} from "models/reports/filters/FilterSetting";
import { reportFilterI18N } from "../i18n/reportfilter-i18n";

@Component({
    selector: "billable-filter",
    templateUrl: "billable-filter.html",
})
export class BillableFilterComponent implements OnInit {
    @Input() public filterSubject: Subject<FilterSettings>;
    public billableOptions: Array<BillableOption>;
    private filterSettings: FilterSettings;
    public i18n;
    public selected = new ReplaySubject<BillableOption[]>(1);
    public preselected = new ReplaySubject<BillableOption[]>(1);

    constructor(private i18nService: I18NService) {
        this.i18n =
            this.i18nService.extractCurrentTranslation(reportFilterI18N);
        this.billableOptions = [
            { name: this.i18n.billable, id: "true" },
            { name: this.i18n.nonBillable, id: "false" },
        ];
    }

    public ngOnInit(): void {
        this.filterSubject.subscribe(
            (filterSettings) => (this.filterSettings = filterSettings)
        );
        this.filterSubject.subscribe((filterSettings) => {
            this.filterSettings = filterSettings;
            const preselected = _.filter(
                filterSettings.settings,
                (fs) => fs.filterType === FilterType.BILLABLE
            ).map((fs) => {
                return { id: fs.filterValue, name: fs.filterDisplay };
            });
            this.preselected.next(preselected);
        });

        this.selected.subscribe((selectedOptions) => {
            _.remove(
                this.filterSettings.settings,
                (fs) => fs.filterType === FilterType.BILLABLE
            );
            if (selectedOptions.length) {
                const option = selectedOptions[0];
                const newSetting =
                    option.id === "true"
                        ? new FilterSetting(
                              FilterType.BILLABLE,
                              "true",
                              this.i18n.billable,
                              false
                          )
                        : new FilterSetting(
                              FilterType.BILLABLE,
                              "false",
                              this.i18n.nonBillable,
                              false
                          );
                this.filterSettings.settings.push(newSetting);
            }
            this.filterSubject.next(this.filterSettings);
        });
    }
}

export type BillableOption = { name: string; id: string };
